"use client";

import { useEffect, useState } from "react";
import HomePortalLink from "@/components/HomePortalLink";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  // LINE 登入流程失敗時會帶 ?error= 導回這頁,顯示出來。
  useEffect(() => {
    const e = new URLSearchParams(window.location.search).get("error");
    if (e) setError(e);
  }, []);

  // 用 LINE 登入:導向後端流程(會處理 state、授權、回呼)。
  function loginWithLine() {
    const next = new URLSearchParams(window.location.search).get("next");
    window.location.href =
      "/api/auth/line/start?mode=login" + (next ? `&next=${encodeURIComponent(next)}` : "");
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const d = await res.json();
    setBusy(false);
    if (!res.ok) {
      setError(d.error ?? "登入失敗");
      return;
    }
    // 導回原本要去的頁面(若有),否則回首頁。
    const next = new URLSearchParams(window.location.search).get("next") || "/";
    window.location.href = next;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      {/* 公司內網統一的「回到主頁」:只在後台登入頁顯示,不出現在客人看的公開頁 */}
      <HomePortalLink fixed />
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
      >
        <div className="mb-6 text-center">
          <div className="text-xl font-bold text-emerald-600">LINE 管理平台</div>
          <div className="text-sm text-gray-400">請登入後台</div>
        </div>

        <label className="mb-3 block text-sm">
          <span className="mb-1 block text-gray-600">帳號 / 工號</span>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
            placeholder="例:T035"
            className="w-full rounded-lg border border-gray-300 px-3 py-2"
          />
        </label>
        <label className="mb-4 block text-sm">
          <span className="mb-1 block text-gray-600">密碼</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            placeholder="用工號登入免填"
            className="w-full rounded-lg border border-gray-300 px-3 py-2"
          />
          <span className="mt-1 block text-xs text-gray-400">
            測試期間員工用工號登入不需密碼(限公司內網);在外面請用 LINE 登入。
          </span>
        </label>

        {error && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50"
        >
          {busy ? "登入中…" : "登入"}
        </button>

        {/* 分隔線 */}
        <div className="my-4 flex items-center gap-3 text-xs text-gray-400">
          <span className="h-px flex-1 bg-gray-200" />
          或
          <span className="h-px flex-1 bg-gray-200" />
        </div>

        {/* 用 LINE 登入(需先用帳密登入並綁定過 LINE) */}
        <button
          type="button"
          onClick={loginWithLine}
          className="w-full rounded-lg bg-[#06C755] px-4 py-2 text-sm font-medium text-white hover:brightness-95"
        >
          用 LINE 登入
        </button>
        <p className="mt-2 text-center text-xs text-gray-400">
          僅限已綁定 LINE 的帳號;員工在官方帳號登記過工號,用工號登入一次就會自動綁定。
        </p>
      </form>
    </div>
  );
}
